export default [
    {
        path: 'relatorio-geral-saida-paciente',
        component: () => import(
            /* webpackChunkName: 'relatorios-relatorio-geral-saida-paciente' */
            '@/views/relatorios/relatorio-geral-saida-paciente/Index'
        ),
        redirect: 'relatorio-geral-saida-paciente/index',
        children: [
            {
                name: 'relatorios-relatorio-geral-saida-paciente-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'relatorios-relatorio-geral-saida-paciente' */
                    '@/views/relatorios/relatorio-geral-saida-paciente/List.vue'
                ),
            },
        ],
    },
]
